import { useEffect, useState } from "react";

import { useNavigate, useParams } from "react-router-dom";

import { PageContainer } from "@/features/ui";

import { apiClient, getErrorMessage } from "@/features/shared";
import { useSnackbar } from "@/features/ui";
import { UserForm } from "@/features/users/user-form/user-form";

import { Button } from "@mui/material";

export const EditUser = () => {
  const { userId } = useParams();
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(true);
  const [defaultValues, setDefaultValues] = useState(null);

  useEffect(() => {
    const fetchUser = async () => {
      setIsLoading(true);
      try {
        const {
          data: {
            data: {
              name,
              username,
              email,
              contactNumber,
              role,
              platform,
              status,
            },
          },
        } = await apiClient.get(`users/${userId}`);
        setDefaultValues({
          name,
          username,
          email,
          contactNumber,
          role,
          platform,
          status,
        });
      } catch (error) {
        showSnackbar(
          getErrorMessage(error, "Gagal memperbarui pengguna")
        );
      } finally {
        setIsLoading(false);
      }
    };
    fetchUser();
  }, [showSnackbar, userId]);

  const handleSubmit = async ({
    name,
    username,
    email,
    contactNumber,
    roleId,
    platform,
    status,
  }) => {
    try {
      await apiClient.put(`users/${userId}`, {
        name,
        username,
        email,
        contactNumber,
        roleId,
        platform,
        status,
      });
      navigate(-1);
    } catch (error) {
      showSnackbar(
        getErrorMessage(error, "Gagal memperbarui pengguna")
      );
    }
  };

  return (
    <PageContainer
      maxWidth="xl"
      title="Ubah Pengguna"
      breadcrumbs={[
        { title: "Pengguna", path: "/setting/users" },
        { title: "Ubah" },
      ]}
    >
      <UserForm
        isLoading={isLoading}
        defaultValues={defaultValues}
        onSubmit={handleSubmit}
        renderActionButton={({ isSubmitting }) => (
          <Button
            type="submit"
            variant="contained"
            loading={isSubmitting}
          >
            Simpan
          </Button>
        )}
      />
    </PageContainer>
  );
};
